// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plan-block[data-v-104b20ec]{scroll-margin-top:50px}@media (min-width:40rem){.plan-block[data-v-104b20ec]{width:50%}}@media (min-width:64rem){.plan-block[data-v-104b20ec]{margin-left:.5rem;margin-right:.5rem;width:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
